import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/(sources)/exchanges/$exchangeId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/exchanges/$exchangeId/summary`,
      params: {
        exchangeId: params.exchangeId,
      },
      replace: true,
    });
  },
});
